export enum beneficiaryTypes {
  bankAccount = "bankAccount",
  gateway = "gateway",
}
